import React, { useState } from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DownloadIcon from "@mui/icons-material/Download";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import BlockIcon from "@mui/icons-material/Block";
import { useDispatch } from "react-redux";
import { getRecordingDownloadUrl } from "../../../../store/RecordedCalls/recordedCallsThunks";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import SideModal from "../../../../components/SideModal";
import RetentionModalContent from "./RetentionModelContent";
import { useTheme } from "@mui/material/styles";
import appConfig from "../../../../config/appConfig";

const ActionCell = ({ id, row, onPlay, onShowParticipants }) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();
  const dispatch = useDispatch();
  const [openRetentionModal, setOpenRetentionModal] = useState(false);

  const handleShowParticipants = () => {
    onShowParticipants(id);
  };

  const handlePlay = () => {
    onPlay(row.id);
  };

  const handleDownload = async () => {
    const action = await dispatch(
      getRecordingDownloadUrl({ recordingId: row.id })
    );

    if (action.meta.requestStatus === "fulfilled") {
      const downloadUrl = action.payload;

      try {
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `recording-${row.id}.mp3`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download failed:", err);
      }
    } else {
      console.error("Download thunk failed:", action.payload);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Tooltip title="Show Participants">
        <IconButton
          onClick={handleShowParticipants}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>

      <Tooltip
        title={appConfig.enableDirectPlayback ? "Play" : "Playback disabled"}
      >
        <span>
          {" "}
          {/* Wrap in span to enable tooltip on disabled button */}
          <IconButton
            onClick={handlePlay}
            size="small"
            disabled={!appConfig.enableDirectPlayback}
            sx={{
              mx: 0.5,
              color: theme.palette.text.primary,
              opacity: appConfig.enableDirectPlayback ? 1 : 0.4,
              cursor: appConfig.enableDirectPlayback
                ? "pointer"
                : "not-allowed",
            }}
          >
            <PlayArrowIcon />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Download">
        <IconButton
          onClick={handleDownload}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>

      <Tooltip
        title={
          row.retainPermanently ? "Release retention" : "Retain permanently"
        }
      >
        <IconButton
          onClick={() => setOpenRetentionModal(true)}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          {row.retainPermanently ? <LockOpenIcon /> : <LockIcon />}
        </IconButton>
      </Tooltip>

      <SideModal
        open={openRetentionModal}
        onClose={() => setOpenRetentionModal(false)}
        title={
          row.retainPermanently ? "Release Retention" : "Retain Permanently"
        }
      >
        <RetentionModalContent
          recordedCall={row}
          onClose={() => setOpenRetentionModal(false)}
        />
      </SideModal>
    </Box>
  );
};

export default ActionCell;
